import { useEffect } from 'react'; // 引入 useEffect
import { Link } from 'react-router-dom';
import { ShieldCheck, Lock, Eye, Database, Share2, Cookie, Mail, ArrowLeft } from 'lucide-react';
import Header from '@/components/Header';

// 定义服务协议的数据结构
const serviceAgreementData = {
  title: "成都孔明智算互联网平台服务条款",
  company: "成都孔明智算互联网科技有限公司",
  websiteUrl: "https://cdkmzs.com",
  ApplicablePlatform: "孔明智算线上采购商城、资讯中心、供应商入驻交易平台 ",
  timeOfEffectiveness: "公示之日起正式执行",

  sections: [
    {
      title: "第一条 总则",
      content: [
        "1.1 本服务条款由成都孔明智算互联网科技有限公司（以下简称“平台方”）制定，是所有访问、注册、入驻、使用cdkmzs.com商城平台全部服务的采购单位、入驻供应商、平台使用用户（以下统称“用户”）必须遵守的法律约定。",
        "1.2 用户进入本平台浏览信息、完成账号注册、提交入驻申请、发布商品、在线下单等任意操作，即代表已完整阅读、充分理解并自愿无条件接受本服务条款全部内容，自愿受本条款约束。 ",
        "1.3 本平台专注于政企单位物资采购、项目物资集采、供需资源对接、商城化交易管理，为正规合规企业采购服务平台，仅提供线上信息展示、交易撮合、流程管控、订单管理、对账结算等技术与商务配套服务。",
        "1.4 平台可根据国家法律法规、行业监管要求、平台运营调整优化本条款，修订内容在cdkmzs.com官网公示后自动生效，用户继续使用平台服务视为认同新版条款。 "
      ]
    },
    {
      title: "第二条 平台服务内容",
      content: [
        "2.1 信息展示服务：为入驻供应商提供产品信息、企业资质、供货能力、服务范围线上展示端口；为采购方提供物资品类查询、货源筛选、商家信息查阅服务。 ",
        "2.2 集采交易服务：支持线上商品选购、订单提交、售后协调全流程线上化管理。",
        "2.3 询比价服务：依托平台实现采购需求发布、多家供应商报价、价格比对、资质比对、择优合作等集采核心功能。",
        "2.4 数据管理服务：提供交易记录、采购台账、供货记录、对账明细、票据信息等数据留存与查询服务。 ",
        "2.5 合规管控服务：对入驻商家资质、上架产品品类、交易行为进行规范化审核与监督，维护集采交易公平公正秩序。"
      ]
    },
    {
      title: "第三条 账号注册与使用规范",
      content: [
        "3.1 所有企业用户须以真实合法企业主体身份完成实名认证、企业信息备案，准确填写企业名称、统一社会信用代码、法人信息、对接人、联系方式、办公地址、对公信息等资料，保证全部信息真实有效。",
        "3.2 用户自行保管平台登录账号、密码、验证码及后台操作权限，凡通过账号发起的采购下单、报价、确认订单、提交资料等行为，均视为企业真实意愿行为，产生全部法律与经济责任由账号所属企业自行承担。",
        "3.3 严禁借用、租借、买卖、共用平台企业账号，严禁虚假注册、冒用企业资质注册账号，一经查实平台有权直接注销账号、封禁权限、取消合作资格。",
        "3.4 用户企业信息、对接人员、开票信息、收货地址等发生变更，须第一时间在平台完成信息更新，因信息未及时变更造成采购错发、对账错误、票据失误等损失由用户自行承担。"
      ]
    },
    {
      title: "第四条 入驻供应商权利与义务",
      content: [
        "4.1 供应商自愿入驻本商城，须严格按照平台入驻流程提交完整入驻资料，包含营业执照、经营资质、行业许可、产品质检报告、授权代理证明等相关合规材料，配合平台完成资质审核。 ",
        "4.2 供应商上架所有商品、物资、配套服务必须符合国家质量标准、安全标准及采购行业使用标准，严禁上架违禁物资、不合格产品、三无产品、过期产品、侵权产品及国家明令禁止交易品类。",
        "4.3 供应商发布产品参数、规格型号、材质用途、供货周期、产品价格、售后保障等内容必须如实填写，不得夸大宣传、隐瞒产品缺陷、虚报产能、恶意抬高报价或恶意低价扰乱采购市场秩序。",
        "4.4 确定成交订单后，供应商须严格按照订单约定规格、数量、质量、交货期限完成供货履约，严格配合采购方完成物资清点、现场验收、资料交接等工作，无正当理由不得拖延交货、拒绝履约、随意变更供货标准。 ",
        "4.5 供应商须积极配合平台日常巡检、产品抽检、履约核查工作，自觉遵守平台集采价格规则、交易规则、售后规则，主动配合处理采购过程中出现的质量异议、供货纠纷。",
        "4.6 供应商不得引导采购方脱离本平台进行私下交易、线下结算、私下签订协议，一经发现平台有权暂停店铺权限、下架全部产品、终止入驻合作。"
      ]
    },
    {
      title: "第五条 采购方用户权利与义务",
      content: [
        "5.1 采购方在平台发起采购需求、提交订单前，应当仔细核实产品规格、型号、单价、总量、交货时间、服务标准、售后范围等全部交易内容，确认提交订单即视为认可全部交易约定。",
        "5.2 采购方应当按照双方约定及平台结算规则按时完成款项核对、款项结算工作，不得无故拖延付款、恶意取消合规订单、无理由拒收合格物资。",
        "5.3 采购方在物资到货后及时完成现场验收，存在数量短缺、规格不符、质量不合格等问题，需在规定时限内通过平台正式渠道提出异议并留存凭证，逾期未提出视为验收合格。",
        "5.4 采购方合理使用平台采购功能，严禁利用平台恶意发布虚假采购需求、恶意压价、恶意多家比价无故弃单、恶意投诉扰乱平台正常经营秩序。"
      ]
    },
    {
      title: "第六条 交易、履约与结算规则",
      content: [
        "6.1 平台线上报价、线上订单、线上确认单据均具备交易效力，可作为双方履约对账有效依据。",
        "6.2 所有平台内交易活动以线上确认内容为准，口头约定、线下私自更改内容未经平台备案不予认可。",
        "6.3 交易结算方式、结算周期、服务费用、履约保证金相关标准，按照供应商服务协议及双方线下合作约定执行。",
        "6.4 发生订单取消、物资退换、补货、合同变更等情况，须在平台完成流程登记备案，双方协商一致后方可执行。"
      ]
    },
    {
      title: "第七条 平台免责与免责声明",
      content: [
        "7.1 平台负责cdkmzs.com网站日常运维、系统升级、网络安全维护、服务器稳定运行，保障商城采购、报价、下单、查询等基础功能正常使用。",
        "7.2 平台仅对入驻企业资质做形式合规审核，无法完全实地核验所有产品实际质量、现场供货实力，不参与交易双方实际货物交割、质量把控，不对交易成果、产品质量、履约能力承担连带担保责任。 ",
        "7.3 因政策调整、政务管控、网络故障、系统维护、自然灾害、突发公共事件等不可抗力因素造成平台服务临时中断、交易延迟，平台不承担由此产生的直接或间接经济损失。",
        "7.4 平台仅作为集采交易服务第三方平台，交易双方因供货质量、货款结算、履约违约产生的一切经济纠纷、法律纠纷，由交易双方自行协商解决，协商无果可通过法律途径处理，平台仅配合提供平台留存交易凭证。",
        "7.5 若因交易一方（“违约方”）违反本服务条款、相关交易约定或法律法规，导致另一方用户（“守约方”）向本平台主张权利、提出索赔、投诉或诉讼，并致使本平台因此承担任何形式的赔偿责任、和解费用、行政罚款或其他经济损失的，本平台有权在承担前述责任后，向违约方全额追偿。",
        "违约方应就本平台因此遭受的全部损失承担赔偿责任，包括但不限于：",
        "（一）本平台向守约方或任何第三方支付的赔偿金、补偿金、和解款项；",
        "（二）本平台为应对相关索赔、诉讼、仲裁或行政程序而支出的全部费用，包括但不限于律师费、诉讼费、仲裁费、保全费、担保费、鉴定费、公证费、差旅费、公告费、执行费等；",
        "（三）本平台因违规行为被监管部门处以的罚款、没收的违法所得；",
        "（四）本平台为调查、处理、平息该等纠纷所支出的合理运营成本及管理成本；",
        "（五）本平台因该等违约行为遭受的其他直接及间接损失。",
        "本平台有权从应付给违约方的任何款项（包括但不限于交易结算款、保证金、服务费等）中直接抵扣上述赔偿款项，抵扣后仍不足的部分，本平台保留通过法律途径继续追偿的权利。"
      ]
    },
    {
      title: "第八条 信息保密与知识产权",
      content: [
        "8.1 平台严格保护所有入驻企业商业信息、采购需求信息、交易数据、涉密业务资料，严守商业保密原则，无合法依据不得向任何第三方泄露用户企业涉密信息。",
        "8.2 成都孔明智算互联网科技有限公司拥有cdkmzs.com网站全部页面设计、平台系统、栏目布局、平台标识、平台文案等全部知识产权，未经我方书面正式授权，任何单位及个人不得复制、仿制、盗用、篡改、二次商用。",
        "8.3 供应商在平台上传的产品图片、宣传文案、企业资料等内容，必须拥有合法使用权限，若出现第三方知识产权侵权纠纷，全部责任与赔偿由上传方自行承担。"
      ]
    },
    {
      title: "第九条 违规行为处罚",
      content: [
        "9.1 凡违反本服务条款任意约定内容，均视为违规行为，平台可根据违规情节采取口头警告、信息整改、产品下架、店铺限流、暂停报价权限、暂停交易权限等处置方式。",
        "9.2 存在资质造假、售卖不合格物资、严重违约履约、恶意扰乱平台秩序、侵害合作方及平台声誉等严重违规行为，平台有权直接终止入驻合作、清退店铺、冻结平台相关款项，同时保留依法追究其法律责任的权利。 "
      ]
    },
    {
      title: "第十条 争议解决与争议调解",
      content: [
        "10.1 本服务条款为cdkmzs.com商城通用正式服务准则，与平台入驻协议、采购合作协议具备同等法律效力。 ",
        "10.2 凡因使用本平台服务产生一切争议，各方优先友好协商解决；协商无法达成一致，统一提交四川省成都市武侯区人民法院诉讼解决。"
      ]
    },
    {
      title: "第十一条 联系方式",
      content: [
        "运营主体：成都孔明智算互联网科技有限公司",
        "官方网址：https://cdkmzs.com",
        "运营地址：四川省成都市武侯区九架车巷55号悦湖数园1栋303室"
      ]
    }
  ]
};

export default function ServiceAgreement() {
    // 添加 useEffect 钩子，在组件挂载时将窗口滚动到顶部
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-16">
      {/* 使用 Header 组件 */}
      <Header />

      <div className="section-container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{serviceAgreementData.title}</h1>
          {/* <p className="text-gray-500">生效日期：{serviceAgreementData.effectiveDate}</p> */}
        </div>

        {/* 主要内容区域 */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10">
          {/* 公司信息 */}
          <div className="space-y-2 text-sm text-gray-600">
            <p><strong>平台主体：</strong>{serviceAgreementData.company}</p>
            <p><strong>官方网址：</strong><Link to={serviceAgreementData.websiteUrl} className="text-[#1c5bff] hover:underline">{serviceAgreementData.websiteUrl}</Link></p>
            <p><strong>适用平台：</strong>{serviceAgreementData.ApplicablePlatform}</p>
            <p><strong>生效时间：</strong>{serviceAgreementData.timeOfEffectiveness}</p>
          </div>

          {/* 各章节内容 */}
          {serviceAgreementData.sections.map((section, index) => (
            <section key={index} className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                {/* <ShieldCheck className="w-6 h-6 text-[#1c5bff]" /> */}
                <h2 className="text-xl font-bold text-gray-900">{section.title}</h2>
              </div>
              <div className="space-y-3">
                {section.content.map((paragraph, pIndex) => (
                  <p 
                    key={pIndex} 
                    className="text-gray-600 leading-relaxed indent-8" // 添加 indent-8 实现首行缩进
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}